import { ChangeDetectionStrategy, Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationService, Toast, ToastType } from '../../../core/services/notification.service';

@Component({
  selector: 'app-toast-container',
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  public constructor(public readonly notificationService: NotificationService) {}

  public onToastHidden(toast: Toast): void {
    this.notificationService.remove(toast);
  }

  public getToastContainerClass(toast: Toast): string {
    switch (toast.type) {
      case ToastType.Error:
        return 'border-danger-500/50 bg-panel-surface';
      case ToastType.Success:
        return 'border-success-500/50 bg-panel-surface';
      case ToastType.Warning:
        return 'border-warning-500/50 bg-panel-surface';
      default:
        return 'border-panel-border bg-panel-surface';
    }
  }

  public getToastHeaderClass(toast: Toast): string {
    switch (toast.type) {
      case ToastType.Error:
        return 'border-danger-500/30 bg-danger-500/20 text-danger-500';
      case ToastType.Success:
        return 'border-success-500/30 bg-success-500/20 text-success-500';
      case ToastType.Warning:
        return 'border-warning-500/30 bg-warning-500/20 text-warning-500';
      default:
        return 'border-panel-border bg-panel-surface2 text-text-primary';
    }
  }

  public getToastBodyClass(toast: Toast): string {
    return 'text-text-primary';
  }

  public getToastHeader(toast: Toast): string {
    switch (toast.type) {
      case ToastType.Error:
        return 'Error';
      case ToastType.Success:
        return 'Success';
      case ToastType.Warning:
        return 'Warning';
      default:
        return '';
    }
  }
}
